import { explicitMaybe } from '@execonline-inc/decoders';
import { array, dateISO, Decoder, field, number, string, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../../../Resource/Decoders';
import {
  createSelectedGroup,
  SelectableUserGroup,
  UserGroup,
} from '../../../../../Form/GroupInputWithSuggestions/Types';
import { createSelectedLicense, License, SelectableLicense } from '../Types';
import {
  DirectoryParticipant,
  DirectoryParticipantResource,
  Participant,
  ParticipantResource,
} from './Types';

const userGroupDecoder: Decoder<UserGroup> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string));

const licenseDecoder: Decoder<License> = succeed({})
  .assign('id', field('id', number))
  .assign('licenseName', field('license_name', explicitMaybe(string)))
  .assign('licenseTypeName', field('license_type_name', string))
  .assign('quantityAvailable', field('quantity_available', number))
  .assign('startOn', field('start_on', dateISO))
  .assign('endOn', field('end_on', dateISO));

const participantDecoder: Decoder<Participant> = succeed({})
  .assign('firstName', field('first_name', string))
  .assign('lastName', field('last_name', string))
  .assign('email', field('email', string))
  .assign(
    'userGroups',
    field('user_groups', array(userGroupDecoder)).map(
      (groups: UserGroup[]): SelectableUserGroup[] => groups.map(createSelectedGroup),
    ),
  )
  .assign(
    'licenses',
    field('licenses', array(licenseDecoder)).map((licenses: License[]): SelectableLicense[] =>
      licenses.map(createSelectedLicense),
    ),
  );

export const participantResourceDecoder: Decoder<ParticipantResource> =
  resourceDecoder(participantDecoder);

const directoryParticipantDecoder: Decoder<DirectoryParticipant> = succeed({})
  .assign('firstName', field('first_name', string))
  .assign('lastName', field('last_name', string))
  .assign('email', field('email', string))
  .assign(
    'userGroups',
    field('user_groups', array(userGroupDecoder)).map(
      (groups: UserGroup[]): SelectableUserGroup[] => groups.map(createSelectedGroup),
    ),
  )
  .assign(
    'licenses',
    field('licenses', array(licenseDecoder)).map((licenses: License[]): SelectableLicense[] =>
      licenses.map(createSelectedLicense),
    ),
  );

export const directoryParticipantResourceDecoder: Decoder<DirectoryParticipantResource> =
  resourceDecoder(directoryParticipantDecoder);
